/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";

import { putRequest } from "utils/request";

import { postRequest } from "utils/request";

import { i18n } from '../../../../translate/i18n';

export default function NewSLA({
  handleNewSLA,
  companyId,
  selectedsla,
  handleGoBack,
  listChannel,
  listTicketType,
  listStatus,
}) {
  const [selectedchannel, setSelectedChannel] = useState("");
  const [selectedtickettype, setSelectedTicket] = useState("");
  const [selectedstatus, setSelectedStatus] = useState("");
  const [selectedtime, setSelectedTime] = useState();
  const [quantity, setQuantity] = useState("");  
  const [message, setMessage] = useState("");  
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);

  const time  = [
    { id: 1, description: "Minutos" },
    { id: 2, description: "Horas" },
    { id: 3, description: "Dias" },
  ];  


  useEffect(() => {
    setLoading(true);

    setSelectedChannel(selectedsla.ChannelId);
    setSelectedTicket(selectedsla.CompanyTicketTypeId);
    setSelectedStatus(selectedsla.CompanyStatusId);
    setSelectedTime(selectedsla.slaDuration);
    setQuantity(selectedsla.quantity);
    setMessage(selectedsla.defaultMessage);

    if (JSON.stringify(selectedsla) !== '{}'){
      setDisabled(true);
    }    
    
    setLoading(false);
  }, []);

  const handleSendSLA = () => {
    setLoading(true);

    if (selectedsla.id) {
      putRequest(`/companiesticketsyslas/${selectedsla.id}`, {
        slaDuration: Number(selectedtime),
        quantity: Number(quantity),
        defaultMessage: message?.length > 0 ? message : null,
      })
      .then(function (response) {
          setLoading(false);
          if(response.success) {
            handleNewSLA();
          }

        }
      )
    } else {
      postRequest(`/companiesticketsyslas`, {
          CompanyId: companyId,
          ChannelId: Number(selectedchannel),
          CompanyTicketTypeId: Number(selectedtickettype),
          CompanyStatusId: Number(selectedstatus),
          slaDuration: Number(selectedtime),
          quantity: Number(quantity),
          defaultMessage: message?.length > 0 ? message : null,
        })
      .then(function (response) {
        setLoading(false);
        if(response.success) {
          handleNewSLA();
        }

        }
      )
    }
  };

  return (
    <>
      {!loading ? (
        <form
          className="form-edit"
          style={{overflow: 'hidden', height: '70vh'}}
          onSubmit={(e) => {
            e.preventDefault();
            handleSendSLA();
          }}
        >
          <div style={{paddingLeft: 0}} className="col-lg-12">
            <div className="form-row">
            <div className="form-group col-md-3">
                <label className="col-form-label">{i18n.t('channel')} *</label>
                <select
                  className="form-control"
                  data-toggle="select2"
                  value={selectedchannel}
                  required
                  disabled={disabled}
                  onChange={(value) => setSelectedChannel(value.target.value)}
                >
                  <option value="">{i18n.t('select')}</option>
                  {listChannel.map((data, index) => (
                    <option key={index} value={data.Channel.id}>
                      {data.Channel.description}
                    </option>
                  ))}
                </select>
              </div>              
              <div className="form-group col-md-3">
                <label className="col-form-label">{i18n.t('type')} *</label>
                <select
                  className="form-control"
                  data-toggle="select2"
                  value={selectedtickettype}
                  required
                  disabled={disabled}
                  onChange={(value) => setSelectedTicket(value.target.value)}
                >
                  <option value="">{i18n.t('select')}</option>
                  {listTicketType.map((data, index) => (
                    <option key={index} value={data.id}>
                      {data.description}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group col-md-3">
                <label className="col-form-label">{i18n.t('status')} *</label>
                <select
                  className="form-control"
                  data-toggle="select3"
                  value={selectedstatus}
                  required
                  disabled={disabled}
                  onChange={(value) => setSelectedStatus(value.target.value)}
                >
                  <option value="">{i18n.t('select')}</option>
                  {listStatus.map((data, index) => (
                    <option key={index} value={data.id}>
                      {data.internalDescription}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-row mt-2">
              <div className="form-group col-md-3">
                <label>{i18n.t('deadLine')} *</label>
                <select
                  className="form-control"
                  data-toggle="select3"
                  defaultValue={selectedtime}
                  value={selectedtime}
                  required
                  onChange={(value) => setSelectedTime(value.target.value)}
                >
                  <option value="">{i18n.t('select')}</option>
                  {time.map((data, index) => (
                    <option key={index} value={data.id}>
                      {data.description}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group col-md-3">
                <label> {i18n.t('quantity')} *</label>
                <input
                  type="number"
                  className="form-control"
                  value={quantity}
                  required
                  onChange={(value) => setQuantity(value.target.value)}
                />
              </div>
            </div>

            <div className="form-row mt-2">
              <div className="form-group col-md-3">
                <label>{i18n.t('message')}</label>
                <textarea
                  type="text"
                  style={{ width: 600 }}
                  rows="3"
                  maxLength={500}
                  className="form-control"
                  value={message}
                  onChange={(value) => setMessage(value.target.value)}
                />
              </div>
            </div>


            <div
              className="button-list mt-3 pull-right"
              style={{ position: "absolute", bottom: 0, right: 0 }}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => handleGoBack()}
              >
                <i i className="mdi mdi-backup-restore"></i>
                {i18n.t('getBack')}
              </button>
              <button type="submit" className="btn btn-outline-success">
                <i className="mdi mdi-checkbox-marked-circle"></i>{i18n.t('save')}
              </button>
            </div>
          </div>
        </form>
      ) : (
        <div className="area-loading">
          <CircularProgress />
        </div>
      )}
    </>
  );
}
